import React from 'react';
import AskSLAMAI from '../../components/chat/AskSLAMAI';

const F1_PROMPTS = [
  { id: 1, text: 'Analyze tire degradation strategy for this race', icon: '🏎️' },
  { id: 2, text: 'Compare qualifying lap telemetry between drivers', icon: '📊' },
  { id: 3, text: 'Pit stop timing optimization for a 2-stop strategy', icon: '⏱️' },
  { id: 4, text: 'Aerodynamic setup differences between wet and dry conditions', icon: '🌧️' },
  { id: 5, text: 'Driver performance trends across the last 5 races', icon: '📈' },
  { id: 6, text: 'Team radio analysis and race engineer communication patterns', icon: '📻' },
];

export default function F1AskAI() {
  return (
    <AskSLAMAI
      sport="f1"
      prompts={F1_PROMPTS}
      endpoint="/api/chat/statcast"
      accentColor="red"
    />
  );
}
